/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiClient } from '@shared/api-client';
import { LicenseClass, Vehicle } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VehiclesService extends ApiClient {
  constructor(private httpClient: HttpClient) {
    super();
  }

  getVehicles(params: {[param: string]: string | string[]; } = {}): Observable<Vehicle[]> {

    return this.httpClient.get<Vehicle[]>(environment.backendServer + '/api/vehicles', {
      headers: this.LD_JSON_HEADERS,
      params
    }).pipe(
      map(response => response['hydra:member'])
    );
  }

  getVehicle(id: string): Observable<Vehicle> {
    return this.httpClient.get<Vehicle>(`${environment.backendServer}/api/vehicles/${this.extractId(id)}`, {
      headers: this.LD_JSON_HEADERS
    });
  }

  createVehicle(vehicle: Vehicle): Observable<Vehicle> {
    return this.httpClient.post<Vehicle>(`${environment.backendServer}/api/vehicles`, vehicle, {
      headers: this.LD_JSON_HEADERS,
      observe: 'response'
    }).pipe(
      map(response => response.body)
    );
  }

  updateVehicle(vehicle: Vehicle): Observable<Vehicle> {
    return this.httpClient.put<Vehicle>(`${environment.backendServer}/api/vehicles/${this.extractId(vehicle['@id'])}`, vehicle, {
      headers: this.LD_JSON_HEADERS,
      observe: 'response'
    }).pipe(
      map(response => response.body)
    );
  }

  deactivateVehicle(vehicle: Vehicle): Observable<Vehicle> {
    return this.httpClient.post<Vehicle>(`${environment.backendServer}/api/vehicle/${this.extractId(vehicle['@id'])}/deactivate`, {}, {
      headers: this.LD_JSON_HEADERS,
      observe: 'response'
    }).pipe(
      map(response => response.body)
    );
  }

  getLicenseClasses(): Observable<LicenseClass[]> {
    return this.httpClient.get<LicenseClass[]>(`${environment.backendServer}/api/vehicles/meta`, {
      headers: this.LD_JSON_HEADERS
    });
  }
}
